"use client";

import { FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";

// import { Twitter, Github, Linkedin } from "lucide-react"

export function FooterSection() {
  return (
    <footer
      id="footer"
      className="w-full max-w-[1320px] mx-auto px-5 flex flex-col md:flex-row justify-between items-start gap-8 md:gap-0 py-10 md:py-[70px]"
    >
      {/* Left Section: Logo, Description, Social Links */}
      <div className="flex flex-col justify-start items-start gap-8 p-4 md:p-8">
        <div className="flex gap-3 items-stretch justify-center">
          <div className="text-center text-foreground text-xl font-semibold leading-4">
            Hamza M.
          </div>
        </div>
        <p className="text-foreground/90 text-sm font-medium leading-[18px] text-left">
          Fullstack Web Developer & Software Engineer
        </p>
        <div className="flex justify-start items-start gap-3">
          <a
            href="https://x.com/HamzaMissewi"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
            className="w-4 h-4 flex items-center justify-center"
          >
            <FaTwitter className="w-full h-full text-muted-foreground hover:text-blue-400 transition-colors" />
          </a>
          <a
            href="https://github.com/hamzaMissewi"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="w-4 h-4 flex items-center justify-center"
          >
            <FaGithub className="w-full h-full text-muted-foreground hover:text-gray-400 transition-colors" />
          </a>
          <a
            href="https://linkedin.com/in/hamza-missewi"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="w-4 h-4 flex items-center justify-center"
          >
            <FaLinkedin className="w-full h-full text-muted-foreground hover:text-blue-600 transition-colors" />
          </a>
        </div>
      </div>
      {/* Right Section: Portfolio Sections */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 p-4 md:p-8 w-full md:w-auto">
        <div className="flex flex-col justify-start items-start gap-3">
          <h3 className="text-muted-foreground text-sm font-medium leading-5">
            Portfolio
          </h3>
          <div className="flex flex-col justify-end items-start gap-2">
            <a
              href="/#home"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              Home
            </a>
            <a
              href="/about"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              About
            </a>
            <a
              href="/skills"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              Skills
            </a>
            <a
              href="/projects"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              Projects
            </a>
            <a
              href="/resume"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              Resume
            </a>
          </div>
        </div>
        <div className="flex flex-col justify-start items-start gap-3">
          <h3 className="text-muted-foreground text-sm font-medium leading-5">
            Services
          </h3>
          <div className="flex flex-col justify-center items-start gap-2">
            <a
              href="/services"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              Services
            </a>
            <a
              href="/chatbot"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              AI Chatbot
            </a>
            <a
              href="/contact"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              Contact
            </a>
            <a
              href="mailto:hamza.missaoui28@gmail.com"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              Email
            </a>
            <a
              href="https://github.com/hamzaMissewi"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              GitHub
            </a>
          </div>
        </div>
        <div className="flex flex-col justify-start items-start gap-3">
          <h3 className="text-muted-foreground text-sm font-medium leading-5">
            Legal
          </h3>
          <div className="flex flex-col justify-center items-start gap-2">
            <a
              href="/tos"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              Terms of Service
            </a>
            <a
              href="/privacy"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              Privacy Policy
            </a>
            {/* <a href="/tos#cookies" className="text-foreground text-sm font-normal leading-5 hover:underline">
              Cookie Policy
            </a>
            <a href="/tos#disclaimer" className="text-foreground text-sm font-normal leading-5 hover:underline">
              Disclaimer
            </a> */}
            <a
              href="/support"
              className="text-foreground text-sm font-normal leading-5 hover:underline"
            >
              Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
